import { Link } from 'react-router';

import AppStoreButton from '../button/AppStoreButton';
import PlayStoreButton from '../button/PlayStoreButton';

export default function Download() {
  return (
    <section id="download" className="py-12 sm:py-16 md:py-20 px-4 bg-white">
      <div className="max-w-5xl mx-auto">
        <div className="rounded-3xl sm:rounded-[2.5rem] bg-gradient-to-br from-green-50 via-green-100/60 to-blue-50 border border-green-100 px-6 py-12 sm:px-12 sm:py-16 md:py-20">
          <div className="flex flex-col items-center text-center">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900">
              Get the{' '}
              <Link
                to="/app"
                className="text-gray-900 hover:text-gray-950 hover:underline font-semibold">
                App
              </Link>{' '}
              on Your Phone
            </h2>
            <p className="mt-4 text-base sm:text-lg text-gray-700 max-w-2xl">
              Take group scheduling anywhere with the{' '}
              <Link
                to="/app"
                className="text-gray-600 hover:text-gray-700 hover:underline font-semibold">
                WhenWeMeet app
              </Link>
              .
              <br />
              Available on iOS and Android.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 mt-8 sm:mt-10">
              <AppStoreButton className="w-auto min-w-[200px]" />
              <PlayStoreButton className="w-auto min-w-[200px]" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
